module.exports = __webpack_public_path__ + "img/grand-pool.9b95668c.jpg";